import React from 'react'
import Banner from '../Components/Banner/Banner'
import Header from '../Components/Header'
import CoinsTable from '../Components/CoinsTable'

function HomePage(){
  return (
    <div>
      <Banner/>
      <CoinsTable/>
    </div>
  )
}

export default HomePage
